<style scoped> 
    .label-custom{
        font-weight: 600;
        font-style: italic;
    }
</style>

<template>
    <div class="form-group">
        <label class="label">{{ label }}</label>
        <app-input
            :placeholder="'Select ' + label "
            type="search-select"
            v-model="selected"
            :list="list"
            :disabled="is_view"
        />
	</div>
</template>
  
<script>
export default {
    name: 'ProductFeatures',
    props: {
        value: {
            type: [String, Number, Object],
            default: null
        },
        list: {
            type: Array,
            required: true
        },
        is_view : {
            type : Boolean,
            default : false,
        },
        label : {
            type: String,
            default : '',
        }
    },
    computed: {
        selected: {
            get() {
                return (this.value && typeof this.value === 'object') ? this.value.id : this.value;
            },
            set(newValue) {
                const fullObject = this.list.find(item => item.id === newValue);
                this.$emit('input', fullObject);
            }
        }
    }
}
</script>